<div class="modal-header" mat-dialog-title>
    <div class="modal-header-icon">
        <mat-icon class="material-symbols-outlined">print</mat-icon>
    </div>
    <div class="modal-header-titles">
        <h2 class="modal-title">Imprimir Etiquetas</h2>
        <span class="modal-subtitle">Selecione o modelo, localização e quantidades de produtos para impressão</span>
    </div>
    <div class="modal-header-close-btn-container">
        <button mat-icon-button type="button" class="modal-close-btn" (click)="fechar()" aria-label="Fechar">
            <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
    </div>
</div>

<mat-dialog-content class="modal-content">
    <!-- Configuração de Etiqueta -->
    <div class="form-section">
        <div class="row">
            <div class="col-12 col-md-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Modelo da Etiqueta</mat-label>
                    <mat-select
                        [(ngModel)]="idConfiguracaoSelecionada"
                        name="idConfiguracaoSelecionada"
                        #modeloEtiquetaCtrl="ngModel"
                        required
                        (selectionChange)="onConfiguracaoChange()">
                        @for (config of listaConfiguracoes; track config.id) {
                        <mat-option [value]="config.id">{{ config.descricao }}</mat-option>
                        }
                    </mat-select>
                    @if ((modeloEtiquetaCtrl.touched || tentativaImpressao) && !idConfiguracaoSelecionada) {
                    <mat-error>Campo obrigatório</mat-error>
                    }
                </mat-form-field>
            </div>

            <div class="col-12 col-md-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Localização</mat-label>
                    <mat-select [(ngModel)]="idLocalizacaoEstoqueSelecionado" (selectionChange)="onLocalizacaoChange()">
                        <mat-option [value]="null">Todos</mat-option>
                        @for (local of listaLocalizacaoEstoque; track local.idLocalizacaoEstoque) {
                        <mat-option [value]="local.idLocalizacaoEstoque">{{ local.nome }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-md-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Lista de Preço</mat-label>
                    <mat-select [(ngModel)]="idListaPrecoSelecionada">
                        @for (item of listaPrecos; track item.listaPreco.idListaPreco) {
                        <mat-option [value]="item.listaPreco.idListaPreco">{{ item.listaPreco.descricao }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-12 col-md-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Lista de Preço Promocional</mat-label>
                    <mat-select [(ngModel)]="idListaPrecoPromocionalSelecionada">
                        <mat-option [value]="null">Nenhuma</mat-option>
                        @for (item of listaPrecosPromocionais; track item.listaPreco.idListaPreco) {
                        <mat-option [value]="item.listaPreco.idListaPreco">{{ item.listaPreco.descricao }}</mat-option>
                        }
                    </mat-select>
                    @if (listaPrecosPromocionais.length === 0) {
                    <mat-hint>Nenhuma lista promocional ativa disponível</mat-hint>
                    }
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <mat-slide-toggle class="app-toggle-compact" [(ngModel)]="usarQuantidadeEstoque"
                    (change)="onCheckboxEstoqueChange()">
                    Utilizar quantidade atual do estoque
                </mat-slide-toggle>
            </div>
        </div>
    </div>

    <!-- Loading configuração -->
    @if (isLoadingConfiguracao) {
    <div class="loading-container">
        <app-loading-box width="100%" height="100px"></app-loading-box>
    </div>
    }

    <!-- Tabela de produtos -->
    <div class="sub-section-container table-section">
        <div class="sub-section-title">
            <mat-icon>inventory_2</mat-icon>
            <span>Produtos ({{ produtos.length }})</span>
        </div>

        <div class="table-responsive">
            <table mat-table [dataSource]="dataSource" matSort>
                <!-- Descrição Column -->
                <ng-container matColumnDef="descricao">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Descrição </th>
                    <td mat-cell *matCellDef="let row"> {{ row.descricao }} </td>
                </ng-container>

                <!-- Código SKU Column -->
                <ng-container matColumnDef="codigoSku">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 150px"> SKU </th>
                    <td mat-cell *matCellDef="let row"> {{ row.codigoSku }} </td>
                </ng-container>

                <!-- Código composto Column -->
                <ng-container matColumnDef="codigoComposto">
                    <th mat-header-cell *matHeaderCellDef style="width: 220px"> Lote/Série </th>
                    <td mat-cell *matCellDef="let row" class="codigo-composto-cell">
                        @if (row.isControlaLotes || row.isControlaSeries) {
                        <mat-form-field appearance="outline" floatLabel="always" class="w-100 codigo-composto-field"
                            [matTooltip]="getCodigoCompostoHint(row)"
                            [matTooltipDisabled]="!getCodigoCompostoHint(row)">
                            <mat-label>{{ getCodigoCompostoLabel(row) }}</mat-label>
                            <mat-select multiple
                                [ngModel]="getCodigoCompostoSelecionado(row)"
                                (ngModelChange)="setCodigoCompostoSelecionado(row, $event)"
                                [disabled]="isCodigoCompostoDisabled(row)">
                                @for (opcao of row.opcoesCodigoComposto; track opcao.id) {
                                <mat-option [value]="opcao.id">{{ opcao.descricao }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        } @else {
                        <span>-</span>
                        }
                    </td>
                </ng-container>

                <!-- Quantidade Column -->
                <ng-container matColumnDef="quantidade">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 130px" class="text-center"> Quantidade </th>
                    <td mat-cell *matCellDef="let row" class="text-center quantity-cell">
                        <mat-form-field appearance="outline" class="quantity-field">
                            <input matInput type="text" inputmode="numeric" [currencyMask]="integerMask" [(ngModel)]="row.quantidade"
                                [disabled]="usarQuantidadeEstoque">
                        </mat-form-field>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>

        <div class="quantity-summary">
            <span>Total de etiquetas: <strong>{{ quantidadeTotal }}</strong></span>
            @if (isLoadingCodigoComposto) {
            <span>Carregando lotes e séries...</span>
            }
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
    <button mat-stroked-button type="button" class="btn-secondary" (click)="fechar()">Cancelar</button>
    <span class="print-action-wrapper"
        [matTooltip]="getImprimirTooltip()"
        [matTooltipDisabled]="!getImprimirTooltip()">
        <button mat-flat-button type="button" class="btn-primary" (click)="gerarEtiquetas()" [disabled]="isImprimirDisabled">
            @if (isLoading) {
            <mat-spinner [diameter]="20"></mat-spinner>
            } @else {
            <span>Imprimir etiquetas</span>
            }
        </button>
    </span>
</mat-dialog-actions>
